import { CommonResponse, RackAckResponse, RackPositionIdRequest, RackPositionResponseModel, RackResponseModel, RackZoneLevelRequest, ReserveRackRequest, RmRackAckResponse, RmRackPositionIdReq, RmRackPositionIdRequestDto, RmRackPositionResponseModel, RmRackPostionRequest, RmReserveRackRequest } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { ZoneIdRequest } from './dto/zone-id.request';
import { SoIdRequest } from './dto/so-id.request';
import { RmRackDTONew } from './dto/rm-rack.dto';
import { RmRackPositionService } from './rm-rack-position.service';
import { RmRackIdRequest } from './dto/rm-rack-id-request';
import { WarehouseDashboardResponseModel } from '@gtpl/shared-models/warehouse-management';
import { RackReserveRequest } from './dto/rm-rack-reserve.request';
import { plantIdRequest } from './dto/plant-request';
import { RackStatusRequestDto } from './dto/rm-rack-status.req';

@ApiTags('rm-rack-position')
@Controller('rm-rack-position')
export class RmRackPositionController {
    constructor(
        private rackService: RmRackPositionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) {}

    /**
     * calling a service to create a new rack
     * @param rackDto 
     * @returns 
    */
     @Post('/createRmRackPosition')
     async createRmRackPosition(@Body() rackDto: RmRackDTONew): Promise<RmRackAckResponse>  {
         try {
             return await this.rackService.createRmRackPosition(rackDto);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RmRackAckResponse, error);
         }
     }
  
     /**
      * callling a service to update a existing rack
      * @param rackDto 
      * @returns 
      */
     @Post('/updateRmRackPosition')
     async updateRmRackPosition(@Body() rackDto: RmRackDTONew): Promise<RmRackAckResponse>  {
         try {
             return await this.rackService.updateRmRackPosition(rackDto);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RmRackAckResponse, error);
         }
     }
  
     /**
      * calling a service to get all racks
      * @returns 
      */
     @Post('getAllRmRacksPositions')
     async getAllRmRacksPositions():Promise<RmRackAckResponse> {
         try {
             return await this.rackService.getAllRmRacksPositions();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RmRackAckResponse, error);
         }
     }
 
     /**
      * calling a service to get all racks by plant id
      * @param plantIdReq
      * @returns 
      */
      @Post('getAllRmRacksByPlantId')
      async getAllRmRacksByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<RmRackAckResponse> {
          try {
              return await this.rackService.getAllRmRacksByPlantId(plantIdReq);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RmRackAckResponse, error);
          }
      }

    /**
     * Activate Or De-Activate Value Rack
     * @param getSingleRack RackResponseModel 
     * @returns Value Rack
     */
    @Post('/activateOrDeactivateRmRack')
    async activateOrDeactivateRmRack(@Body() rackReq: RmRackPostionRequest): Promise<RmRackAckResponse> {
        try {
            return await this.rackService.activateOrDeactivateRmRack(rackReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RmRackAckResponse, err);
        }
    }

    @Post('getRmRacksForRackId')
      async getRmRacksForRackId(@Body() rackPostionRequest: RmRackIdRequest):Promise<RmRackPositionResponseModel> {
          try {
              return await this.rackService.getRmRacksForRackId(rackPostionRequest);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RmRackPositionResponseModel, error);
          }
      }
      @Post('getWarehouseRackDetails')
        async getWarehouseRackDetails(@Body() req: RackReserveRequest): Promise<WarehouseDashboardResponseModel> {
          try {
              return await this.rackService.getWarehouseRackDetails(req);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(WarehouseDashboardResponseModel, error);
          }
      }
    @Post('getReserveRackPosition')
        async getReserveRackPosition(@Body() req: RmReserveRackRequest): Promise<CommonResponse> {
        try {
            return await this.rackService.getReserveRackPosition(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(WarehouseDashboardResponseModel, error);
        }
    }
    @Post('getRmRackPostionsForLocationMapping')
        async getRmRackPostionsForLocationMapping(@Body() req: plantIdRequest): Promise<CommonResponse> {
        try {
            return await this.rackService.getRmRackPostionsForLocationMapping(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(WarehouseDashboardResponseModel, error);
        }
    }
    @Post('getReverseLocationAvailability')
        async getReverseLocationAvailability(@Body() req: RmRackPositionIdRequestDto): Promise<CommonResponse> {
        try {
            return await this.rackService.getReverseLocationAvailability(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(WarehouseDashboardResponseModel, error);
        }
    }
    @Post('updateRmLocationStatus')
        async updateRmLocationStatus(@Body() req: RackStatusRequestDto): Promise<CommonResponse> {
        try {
            console.log(req,'reuest')
            return await this.rackService.updateRmLocationStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('getRmZones')
        async getRmZones(@Body() req:plantIdRequest): Promise<CommonResponse> {
        try {
            return await this.rackService.getRmZones(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getLocationsForStockEntryScreen')
    async getLocationsForStockEntryScreen(): Promise<CommonResponse> {
    try {
        return await this.rackService.getLocationsForStockEntryScreen();
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

     @Post('/updateLocationData')
     async updateLocationData(@Body() dto:RmRackPositionIdReq):Promise<CommonResponse>{
        try{
            return await this.rackService.updateLocationData(dto.rmRackPositionId);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
     }
}
